import { Component, UpdatableComponent } from "../shared/shell/component";
import { Dialog } from "../shared/shell/dialog";
import { Module } from "../shared/shell/module";
import { showOkCancel, showWarning, showException, showGenericError, showInfo, showTextArea, showYesNo, showYesNoCancel, showDeleteCancel } from "../shared/shell/msgbox/msgbox";
import { confirmAll } from "../shared/shell/shell";

export const shell = {
    Module,
    Component,
    Dialog,
    UpdatableComponent,
    showOkCancel,
    showWarning,
    showException,
    showGenericError,
    showInfo,
    showTextArea,
    showYesNo,
    showYesNoCancel,
    showDeleteCancel,
    confirmAll
}

